import React from 'react';
import './Home.css';
import Menu from '../menu/Menu';

export default props => {
    return (
        <>
        
        <div className="principal" >
            <Menu />
            <div className="home">
                <div className="logo">
                    <div className="holerite">
                        <img src="Holerite.png" alt="Holerite" />
                    </div>
                    <div className="logodisnorte">
                        <img src="logoDisnorte.png" alt="" />
                    </div>
                    <div className='versao'>
                        <h2>HOn Holerite On-line</h2>
                        <h3>Versão: 1.0</h3>
                    </div>
                </div>

            </div>
           

        </div>
        </>
    )
}